import {Writable, writable} from 'svelte/store';
// import type {UserData} from "./Types"
// export const users: Writable<UserData[]> = writable([]);
export const overlay: Writable<string|null> = writable(null)

export const modal:Writable<boolean|null> = writable(null);
